import React, {useCallback, useEffect} from 'react';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
import { WheatDecoration, WheatBorder } from '../ui/WheatDecoration';
import { useSignup } from '../../context/SignupContext';
import { SignupStep } from '../../types';

export const LandingPage: React.FC = () => {
  const { setCurrentStep } = useSignup();

  const handleGetStarted = useCallback(() => {
    setCurrentStep(SignupStep.SIGNUP);
  }, [setCurrentStep]);

  // Add keyboard event listener for Enter key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        handleGetStarted();
      }
    };

    // Add event listener when component mounts
    window.addEventListener('keydown', handleKeyDown);
    
    // Clean up event listener when component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleGetStarted]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="container">
        <div className="space-y-6 animate-fade-in-up">
          {/* Main Content Card */}
          <Card className="text-center">
            <div style={{ marginBottom: '1.5rem' }}>
              <WheatBorder />
              <div className="text-center">
                <h1 className="text-3xl font-script font-bold text-bakery-dark-brown" style={{ marginBottom: '0.5rem', marginTop: '1rem' }}>
                  Grace & Grain
                </h1>
                <p className="text-lg text-bakery-brown font-serif">
                  Cottage Bakery
                </p>
              </div>
              <h2 className="text-2xl font-serif font-bold text-bakery-dark-brown" style={{ marginBottom: '1rem' }}>
                Welcome to Our Text Ordering System
              </h2>
              <p className="text-bakery-brown" style={{ lineHeight: '1.6', marginBottom: '1rem' }}>
                Join our exclusive text-based ordering system for fresh-baked breads, 
                pastries, and seasonal treats delivered straight from our cottage kitchen.
              </p>
              <div className="wheat-list">
                <div className="wheat-list-item">
                  <WheatDecoration size="sm" />
                  <span>Order via text message</span>
                </div>
                <div className="wheat-list-item">
                  <WheatDecoration size="sm" />
                  <span>Personalized recommendations</span>
                </div>
                <div className="wheat-list-item">
                  <WheatDecoration size="sm" />
                  <span>Fresh daily notifications</span>
                </div>
              </div>
            </div>

            <div className="space-y-4" role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && handleGetStarted()}>
              {/* Add role and tabIndex for better accessibility */}
              <Button 
                onClick={handleGetStarted}
                size="lg"
              >
                Get Started
              </Button>
              <p className="text-xs text-gray-500">
                By signing up, you'll receive SMS notifications about fresh items and special offers.
              </p>
            </div>
          </Card>

          {/* Footer */}
          <div className="text-center text-sm text-bakery-brown">
            <p>Made with ❤️ in your neighborhood</p>
          </div>
        </div>
      </div>
    </div>
  );
};
